import React from 'react';

const OutreachSection: React.FC = () => {
  return (
    <section className="outreach-section py-5 bg-light">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6 mb-4 mb-lg-0">
            <img
              src="/assets/images/ambulance.jpg"
              alt="StampOutSuicide.org outreach vehicle"
              className="img-fluid rounded shadow"
              style={{ width: '101%' }}
            />
          </div>
          <div className="col-lg-6 text-center text-lg-start">
            <h3 className="display-5 fw-bold mb-4">Spreading Hope Everywhere</h3>
            <p className="lead">
              Look for us with the StampOutSuicide.org Machine as we spread the word!
            </p>
            <p>
              Our outreach team travels to communities, events, and public spaces to
              share messages of hope and connect people with resources they need.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OutreachSection;
